/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function CgTextures(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.075 20.925V19.525L19.525 3.075H20.95V4.475L4.475 20.925H3.075ZM3 14.7V11.9L11.9 3H14.7L3 14.7ZM3 7V3H7L3 7ZM17 21L21 17V21H17ZM9.3 21L21 9.3V12.1L12.1 21H9.3Z"
        fill="currentColor"
      />
    </svg>
  )
}

CgTextures.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default CgTextures
